<template>
  <v-dialog v-model="openModal" persistent max-width="600px">
    <v-card>
      <v-toolbar
        elevation="0"
        color="background"
        class="fluid-toolbar mb-0 px-0"
        height="64"
      >
        <v-toolbar-title class="mr-0 pageTitle newTitle--text">
          {{
            $t(
              'message.pages.credits.creditsAutoRechargeModal.autoRechargeConfig'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="handleClose" class="no-ripple mdi-icon">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="pb-0">
        <v-container class="py-0">
          <v-row
            style="justify-content: space-around"
            class="my-4 border-settings"
            :class="$vuetify.theme.dark ? 'theme--dark' : 'theme--light'"
          >
            <v-col cols="12" md="3" class="center-content py-4">
              <div class="settings-control div-align">
                <label class="label-settings"
                  >{{
                    $t(
                      'message.pages.credits.creditsAutoRechargeModal.triggerLabel1'
                    )
                  }}<br />{{
                    $t(
                      'message.pages.credits.creditsAutoRechargeModal.triggerLabel2'
                    )
                  }}</label
                >
                <div class="py-2">
                  <v-row align="center" no-gutters class="no-wrap">
                    <v-col cols="12">
                      <div class="text-field-container">
                        <v-text-field
                          v-model="settings.trigger"
                          ref="textFieldTrigger"
                          :class="{
                            'newTitle--text text-h6': $vuetify.theme.dark,
                          }"
                          class="center-text pa-0 ma-0 input-settings-border icon-input-alignment-trigger"
                          type="number"
                          style="width: 78px; height: 40px; align-items: center"
                          hide-details
                          @focus="onFocus('trigger')"
                          @blur="onBlur('trigger')"
                          @input="handleInput(settings.trigger, 'trigger')"
                        >
                          <template v-slot:label>
                            <v-card
                              width="20"
                              height="20"
                              flat
                              style="opacity: 0.5"
                            >
                              <v-img
                                src="../../../assets/credit_small_icon.svg"
                              />
                            </v-card>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <span class="center-content nowrap">{{
                  $t(
                    'message.pages.credits.creditsAutoRechargeModal.triggerMin'
                  )
                }}</span>
              </div>
            </v-col>
            <v-icon class="mt-2 icon-opacity">mdi-chevron-right</v-icon>
            <v-col cols="12" md="3" class="center-content py-4">
              <div class="settings-control div-align">
                <label class="label-settings">{{
                  $t(
                    'message.pages.credits.creditsAutoRechargeModal.autoRechargeAction'
                  )
                }}</label>
                <div class="py-2">
                  <v-row align="center" no-gutters class="no-wrap">
                    <v-col cols="12">
                      <div class="text-field-container">
                        <v-text-field
                          v-model="settings.action"
                          ref="textFieldAction"
                          :class="{
                            'newTitle--text text-h6': $vuetify.theme.dark,
                          }"
                          class="center-text pa-0 ma-0 input-settings-border icon-input-alignment-action"
                          type="number"
                          style="width: 78px; height: 40px; align-items: center"
                          hide-details
                          @focus="onFocus('action')"
                          @blur="onBlur('action')"
                          @input="handleInput(settings.action, 'action')"
                        >
                          <template v-slot:label>
                            <v-card
                              width="20"
                              height="20"
                              flat
                              style="opacity: 0.5"
                            >
                              <v-img
                                src="../../../assets/credit_small_icon.svg"
                              />
                            </v-card>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <span class="center-content nowrap">{{
                  $t(
                    'message.pages.credits.creditsAutoRechargeModal.triggerMin'
                  )
                }}</span>
              </div>
            </v-col>
            <v-icon class="mt-2 icon-opacity">mdi-equal</v-icon>
            <v-col cols="12" md="3" class="center-content pl-6">
              <div class="settings-control">
                <label class="label-settings pt-2">Total</label>
                <v-row
                  align="center"
                  no-gutters
                  style="justify-content: center"
                  class="mt-4"
                >
                  <div
                    class="total-settings center-content"
                    :style="
                      $vuetify.theme.dark
                        ? 'color: #ffffff'
                        : 'color: var(--v-brand-darken1)'
                    "
                  >
                    {{ calculateTotal() }}
                  </div>
                </v-row>
                <span class="center-content pt-2 nowrap"
                  >{{ currencySign }}
                  {{
                    $t(
                      'message.pages.credits.creditsAutoRechargeModal.creditPrice'
                    )
                  }}</span
                >
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="pb-6 pr-6">
        <v-spacer></v-spacer>
        <BaseBtn
          v-if="isAutoRechargeEnabled"
          type="primary"
          @click="updateAutoRecharge"
          :loading="autoRechargeSettingsLoading"
          :disabled="!hasChanges || requestSuccess || requestError"
        >
          <template>{{
            $t(
              'message.pages.credits.creditsAutoRechargeModal.autoRechargeEdit'
            )
          }}</template>
        </BaseBtn>
        <BaseBtn
          v-else
          type="primary"
          @click="activateAutoRecharge"
          :loading="autoRechargeSettingsLoading"
          :disabled="requestError"
          >{{
            $t(
              'message.pages.credits.creditsAutoRechargeModal.toggleAutoRecharge'
            )
          }}</BaseBtn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import BaseBtn from '@/components/BaseBtn.vue'
import planApi from '@/services/planApi'
import _ from 'lodash'
import { mapMutations } from 'vuex'
import i18n from '@/translations/lang'
export default {
  components: {
    BaseBtn,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isAutoRechargeEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openModal: false,
      settings: {
        trigger: 100,
        action: 100,
      },
      autoRechargeSettingsLoading: null,
      initialSettings: null,
      hasChanges: null,
      requestSuccess: null,
      requestError: null,
      isCardPaymentSource: true,
      isFocused: null,
    }
  },
  computed: {
    currencySign() {
      let currencySign = 'R$'
      const currency = this.$root.$store.state.user.userPlanInfo.currency
      if (currency !== 'brl') {
        currencySign = '$'
      }
      return currencySign
    },
    inputTextColor() {
      return this.$vuetify.theme.dark ? '#ffffff' : '#636578'
    },
    totalBackgroundColor() {
      return this.$vuetify.theme.dark ? '#061879' : '#EBEEFF'
    },
  },
  watch: {
    value(newVal) {
      this.openModal = newVal
    },
    openModal(newVal) {
      const _this = this
      if (newVal) {
        setTimeout(() => {
          _this.setAlignmentOnMounted()
        }, 50)

        if (this.isAutoRechargeEnabled) {
          this.initialSettings = _.cloneDeep(this.settings)
          this.hasChanges = false
        }
      }
      this.$emit('input', newVal)
    },
    inputTextColor(newColor) {
      document.documentElement.style.setProperty('--input-text-color', newColor)
    },
    totalBackgroundColor(newColor) {
      document.documentElement.style.setProperty(
        '--total-background-color',
        newColor
      )
    },
    requestSuccess(success) {
      if (success) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t(
            'message.pages.credits.creditsAutoRechargeModal.autoRechargeSuccess'
          ),
          type: 'success',
        })
      }
    },
    requestError(error) {
      const errorMessage = this.isCardPaymentSource
        ? 'autoRechargeError'
        : 'autoRechargeNoCreditCardTooltip'
      if (error) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t(
            `message.pages.credits.creditsAutoRechargeModal.${errorMessage}`
          ),
          type: 'error',
        })
      }
    },
  },
  mounted() {
    this.setInputTextColor()
    this.setTotalBackgroundColor()
    this.$root.$on('updateSettingsValues', (trigger, action) => {
      this.settings.trigger = trigger
      this.settings.action = action
    })
    this.$root.$on('autoRechargeDisabled', () => {
      this.initialSettings = null
      this.hasChanges = null
      this.requestSuccess = null
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t(
          'message.pages.credits.creditsAutoRechargeModal.autoRechargeSuccess'
        ),
        type: 'success',
      })
    })
    this.$root.$on('paymentSourceType', (type) => {
      if (type !== 'card') {
        this.isCardPaymentSource = false
      }
    })
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    calculateTotal() {
      let factor = 1
      const currency = this.currencySign
      let formattedTotal
      const formatCurrencyUS = new Intl.NumberFormat('US', {
        style: 'currency',
        currency: 'USD',
      })
      const formatCurrencyBR = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
      const total = (this.settings.action * factor).toFixed(2)
      formattedTotal = formatCurrencyBR.format(total)
      if (currency === '$') {
        formattedTotal = formatCurrencyUS.format(total)
      }
      return formattedTotal
    },
    async activateAutoRecharge() {
      this.autoRechargeSettingsLoading = true
      const settings = this.settings
      try {
        if (this.isCardPaymentSource === false)
          throw new Error('Payment method is not valid')
        await planApi.enableCreditsAutoRecharge(settings)
        this.updateVariablesOnSuccess()
        this.$root.$emit('isAutoRechargeEnabled', true)
      } catch (error) {
        console.error(error)
        this.requestError = true
        this.autoRechargeSettingsLoading = false
      }
    },
    async updateAutoRecharge() {
      this.autoRechargeSettingsLoading = true
      const settings = this.settings
      try {
        await planApi.updateCreditsAutoRecharge(settings)
        this.updateVariablesOnSuccess()
      } catch (error) {
        console.error(error)
        this.requestError = true
        this.autoRechargeSettingsLoading = false
      }
    },
    handleClose() {
      this.openModal = false
      this.requestSuccess = false
      this.requestError = false
    },
    setInputTextColor() {
      document.documentElement.style.setProperty(
        '--input-text-color',
        this.inputTextColor
      )
    },
    setTotalBackgroundColor() {
      document.documentElement.style.setProperty(
        '--total-background-color',
        this.totalBackgroundColor
      )
    },
    checkChanges() {
      this.requestSuccess = false
      const isEqual = _.isEqual(this.initialSettings, this.settings)
      if (isEqual) {
        this.hasChanges = false
      } else {
        this.hasChanges = true
      }
    },
    updateVariablesOnSuccess() {
      this.autoRechargeSettingsLoading = false
      this.requestSuccess = true
      this.initialSettings = _.cloneDeep(this.settings)
      this.hasChanges = false
    },
    onFocus(src) {
      this.isFocused = true
      this.setIconInputAlignment(src, 'focus')
    },
    onBlur(src) {
      this.isFocused = false
      this.checkInputValues()
      this.setIconInputAlignment(src, 'blur')
      this.checkChanges()
    },
    setIconInputAlignment(src, event) {
      let translateSize
      let inputLength
      const setAlignment = event === 'blur'
      let scale = setAlignment ? 'scale(1)' : 'scale(0.75)'

      if (setAlignment) {
        src === 'action'
          ? (inputLength = this.settings.action.toString().length)
          : (inputLength = this.settings.trigger.toString().length)

        if (inputLength === 3) translateSize = ['12px', '12px']
        if (inputLength === 4) translateSize = ['8px', '12px']
        if (inputLength === 5) translateSize = ['4px', '12px']
      } else {
        translateSize = ['-18px', '0px']
      }

      const $textfieldIconEl = document.querySelector(
        `.icon-input-alignment-${src} .v-label`
      )
      const $textfieldInputEl = document.querySelector(
        `.icon-input-alignment-${src} input`
      )

      if ($textfieldIconEl)
        $textfieldIconEl.style.transform = `translateX(${translateSize[0]}) ${scale}`

      if ($textfieldInputEl)
        $textfieldInputEl.style.transform = `translateX(${translateSize[1]})`
    },
    setAlignmentOnMounted() {
      this.setIconInputAlignment('action', 'blur')
      this.setIconInputAlignment('trigger', 'blur')
    },
    checkInputValues() {
      let { action, trigger } = this.settings
      if (action < 100) this.settings.action = 100

      if (action > 99999) this.settings.action = 99999

      if (trigger < 100) this.settings.trigger = 100

      if (trigger > 99999) this.settings.trigger = 99999
    },
    handleInput(value, ref) {
      const maxLength = 5
      const isAction = ref === 'action'

      if (value.toString().length > maxLength) {
        if (isAction) {
          this.$refs.textFieldAction.blur()
        } else {
          this.$refs.textFieldTrigger.blur()
        }
        return
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.settings-control label {
  display: block;
  font-weight: bold;
}
.settings-control span {
  font-size: 12px;
  color: gray;
}
::v-deep div.v-input.center-text {
  div.v-input__control {
    padding: 1px;
    justify-content: space-evenly;
    .v-input__slot {
      .v-text-field__slot {
        input {
          text-align: center;
          color: var(--input-text-color);
          font-size: 14px;
        }
      }
    }
  }
}
::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
  border: none !important;
}
.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.label-settings {
  text-align: center;
  width: 127px;
  line-height: 16px;
}
.input-settings-border.theme--light {
  border: 1px solid #d0d1d9;
  border-radius: 4px;
}
.input-settings-border.theme--dark {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
}
.no-wrap {
  flex-wrap: nowrap !important;
}
.total-settings {
  height: 40px;
  width: 100px;
  background-color: var(--total-background-color);
  border-radius: 4px;
}
.icon-opacity {
  color: #d0d1d9;
}
::v-deep .v-text-field > .v-text-field--enclosed > .v-text-field__slot input {
  width: calc(100% - 40px);
}
.div-align {
  display: flex;
  flex-direction: column;
  align-items: center;
}
::v-deep .v-toolbar__content {
  padding-left: 24px !important;
  padding-right: 8px !important;
}
.nowrap {
  white-space: nowrap;
}
::v-deep .v-text-field .v-label {
  transition: all 0.2s ease;
  position: absolute;
  display: flex;
  align-items: center;
}
.text-field-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
::v-deep .v-text-field input {
  text-align: center;
  transition: all 0.2s ease;
}
::v-deep .icon-input-alignment-action .v-label {
  transform: translateX(12px);
}
::v-deep .icon-input-alignment-action input {
  transform: translateX(12px);
}
::v-deep .icon-input-alignment-trigger .v-label {
  transform: translateX(12px);
}
::v-deep .icon-input-alignment-trigger input {
  transform: translateX(12px);
}
.border-settings.theme--light {
  border: 1px solid var(--v-neutral-lighten3) !important;
}
.border-settings.theme--dark {
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
}
</style>
